module.exports = __webpack_public_path__ + "media/images/static/merits/merit_02-46f9c35c08dfa3443de23701698f201e.png";